import config from '../../../config';

const baseUrl = `${config.apiUrl()}/Offenders`;

export default {
  baseUrl: (): string => `${baseUrl}`,
  baseContentUrl: (): string => `${baseUrl}/Content`,
};
